import { useEffect, useState } from "react";
import { AlertTriangle, Loader2, Monitor, Smartphone } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export const PreviewDialog = ({
  open,
  onOpenChange,
  title,
  description,
  html,
  loading = false,
  error = "",
  testIdPrefix,
}) => {
  const [viewport, setViewport] = useState("desktop");

  useEffect(() => {
    if (open) setViewport("desktop");
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid={`${testIdPrefix}-modal`}
        closeTestId={`${testIdPrefix}-close-btn`}
        className="w-[calc(100vw-1.5rem)] max-w-6xl border-slate-700 bg-slate-950 p-4 text-white sm:p-6"
      >
        <DialogHeader className="pr-10">
          <DialogTitle data-testid={`${testIdPrefix}-title`}>{title}</DialogTitle>
          <DialogDescription data-testid={`${testIdPrefix}-description`} className="text-slate-400">
            {description}
          </DialogDescription>
        </DialogHeader>

        <div className="flex justify-center sm:justify-end">
          <div className="inline-flex rounded-md border border-slate-700 bg-slate-900 p-1" data-testid={`${testIdPrefix}-viewport-switcher`}>
            <button
              type="button"
              onClick={() => setViewport("desktop")}
              data-testid={`${testIdPrefix}-viewport-desktop`}
              className={`flex items-center gap-2 rounded px-3 py-2 text-sm transition-colors ${viewport === "desktop" ? "bg-cyan-500 text-slate-950" : "text-slate-300 hover:bg-slate-800"}`}
            >
              <Monitor className="h-4 w-4" /> Desktop
            </button>
            <button
              type="button"
              onClick={() => setViewport("mobile")}
              data-testid={`${testIdPrefix}-viewport-mobile`}
              className={`flex items-center gap-2 rounded px-3 py-2 text-sm transition-colors ${viewport === "mobile" ? "bg-cyan-500 text-slate-950" : "text-slate-300 hover:bg-slate-800"}`}
            >
              <Smartphone className="h-4 w-4" /> Mobile
            </button>
          </div>
        </div>

        <div className="flex min-h-[420px] items-stretch justify-center overflow-hidden rounded-md border border-slate-700 bg-slate-900 p-2 sm:p-4">
          {loading ? (
            <div className="flex items-center gap-3 text-slate-300" data-testid={`${testIdPrefix}-loading`}>
              <Loader2 className="h-5 w-5 animate-spin text-cyan-400" /> Loading preview…
            </div>
          ) : error ? (
            <div className="m-auto flex max-w-md items-center gap-3 text-amber-300" data-testid={`${testIdPrefix}-error`}>
              <AlertTriangle className="h-5 w-5 shrink-0" /> {error}
            </div>
          ) : (
            <iframe
              title={`${title} preview`}
              srcDoc={html}
              sandbox=""
              referrerPolicy="no-referrer"
              data-testid={`${testIdPrefix}-frame`}
              className={`h-[58vh] min-h-[390px] max-h-[680px] bg-white transition-[width] duration-300 ${viewport === "mobile" ? "w-[375px] max-w-full" : "w-full"}`}
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};